import { useMemo } from "react"
import ReactMarkdown from "react-markdown"
import rehypeRaw from "rehype-raw"
import remarkGfm from "remark-gfm"

import { cn } from "@/lib/utils"

export default function Markdown({
  className,
  children,
  sectionTitles,
}: {
  className?: string
  children: string
  sectionTitles?: unknown[]
}) {
  // Wrap in a memo so that this component ONLY re-renders when the props are changed
  const MarkdownMemo = useMemo(() => {
    return (
      <ReactMarkdown
        className={cn(className, "markdown relative")}
        rehypePlugins={[rehypeRaw, remarkGfm]}
        components={{
          a: ({ ...props }) => (
            <a
              // Open non-anchor-tag links in new tabs
              target={props.href?.slice(0, 1) === "#" ? undefined : "_blank"}
              rel="noreferrer"
              {...props}
            />
          ),
        }}
      >
        {children}
      </ReactMarkdown>
    )
  }, [children, className, sectionTitles])

  return MarkdownMemo
}
